export const classes = {
  wrapper: 'flex justify-between items-end gap-4 flex-wrap',
  withActions: 'mb-5',
  titleBlock: 'flex flex-col min-w-[200px]',
  controls: 'place-end gap-3',
  title: 'text-taupe-3 text-[23px] font-extrabold tracking-tight',
  subtitle: 'text-taupe-2 text-[13px] font-normal',
};
